import { LoginIcon, LogoutIcon, UserIcon } from '../../icons';
import ActionIconButton from './ActionIconButton';
import { resetUrlFilters } from '../../pages/activitycards/components/urlFiltering';

function GuestActionButtons({ customer, guestId, loginAsCustomerWithId, cartItemCount, showModal }) {
    const isLoggedInAsThisGuest = customer && customer.id === guestId;

    return (
        <>
            {isLoggedInAsThisGuest ? (
                <ActionIconButton
                    title="Logout"
                    icon={LogoutIcon}
                    onClick={() => {
                        loginAsCustomerWithId(null, showModal);
                        if (cartItemCount === 0) {
                            resetUrlFilters();
                        }
                    }}
                />
            ) : (
                <ActionIconButton
                    title="Login as guest"
                    icon={LoginIcon}
                    onClick={() => {
                        loginAsCustomerWithId(guestId, showModal);
                    }}
                />
            )}
            <ActionIconButton
                title="View guest"
                icon={UserIcon}
                to={`/guests/${guestId}`}
            />
        </>
    );
}

export default GuestActionButtons;
